import apiClient from "./api";

export interface Branch {
  id?: number;
  code: string;
  name: string;
  image?: string;
  user_id?: number;
  email?: string;
  phone?: string;
  status?: number;
}

const branchService = {
  async getBranches(): Promise<Branch[]> {
    const response = await apiClient.get("/branches");
    return response.data.data ?? response.data;
  },
};

export default branchService;
